import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { DesignSidebarItem } from '../Components/DesignSidebarItem';

export const DailyBonusBadgesSecondarySidebar: React.FC = () => {
  const { relevantDailyBonusBadgesDesigns } = useTemplateStudioState();

  return (
    <>
      {relevantDailyBonusBadgesDesigns?.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="dailyBonusBadge.selectedDesignId"
        />
      ))}
    </>
  );
};
